import { createSelector } from 'reselect';
import getPropFromModule from './getPropFromModule';

const getCartFeaturedProduct = createSelector(
  state => getPropFromModule(state, 'featuredProduct'),
  featuredProduct => featuredProduct || null,
);

export default getCartFeaturedProduct;
